(function HotelEngine($, Adzuki)
{
	'use strict';

	const appConfig = {
		data() {
			return {
				baseUri       : Adzuki.base_uri,
				siteUrl       : Adzuki.current_website,
				componentProps: {},
				coordinates   : {},
				hotels        : [],
				formData      : {
					locationSearch: '',
					locationRadius: '',
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : []
				},
				isLoading            : true,
				isLoadingHotel       : false,
				numNights            : 0,
				totalRooms           : 0,
				skipRoomsWatcher     : false,
				shouldAutoSubmit     : false,
				datasetSearchCriteria: null,
				datasetSearchLocation: null,
				showAlert            : false,
				alertTitle           : null,
				alertMessage         : null,
				alertType            : null,
				pendingToast         : null
			};
		},
		methods: {
			clearData() {
				sessionStorage.removeItem('formData');
				sessionStorage.removeItem('coordinates');
				sessionStorage.removeItem('searchCriteria');
				sessionStorage.removeItem('locationSearch');
				sessionStorage.removeItem('searchLocation');
				sessionStorage.removeItem('giataId');
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.removeItem('selectedRoom');
				sessionStorage.removeItem('rate_select_string');


				this.$hotelDb.deleteDB();

				this.formData = {
					locationSearch: '',
					locationRadius: '',
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : [],
				};
				this.coordinates = {};

				this.formData.rooms = Array.from({length: this.formData.numRooms}, (_, index) => ({
					roomNumber  : index + 1,
					numAdults   : 2,
					numChildren : 0,
					childrenAges: []
				}));

				this.showSearch = true;
				this.hotels     = [];
			},
			setFormData(data) {
				this.formData = data;
			},
			async reverseGeocodeLocation(lat, lng) {
				const url = `${this.baseUri}/HotelEngine/getCityByCoords/${lat}/${lng}`;
				try {
					const response = await fetch(url);
					if (!response.ok) {
						console.error(`Failed to fetch city: ${response.statusText}`);
						return null;
					}
					const data = await response.json();
					if (!data.status || !data.results) {
						return null;
					}
					return data.results;
				} catch (error) {
					console.error('Error fetching City from coords:', error);
					return null;
				}
			},
			openAlert(type, title, message) {
				this.showAlert    = true;
				this.alertTitle   = title;
				this.alertMessage = message;
				this.alertType    = type;
			},
			openToast(status, message, options) {
				const toastComponent = this.$refs && this.$refs.toast;

				if (!toastComponent || typeof toastComponent.openToast !== 'function') {
					this.pendingToast = {
						status,
						message,
						options: options || {}
					};
					return;
				}

				toastComponent.openToast(status, message, options || {});
			},
		},
		computed: {
			totalGuests() {
				return this.formData.rooms.reduce((total, room) => {
					const adults   = parseInt(room.numAdults) || 0;
					const children = parseInt(room.numChildren) || 0;

					return total + adults + children;
				}, 0);
			}
		},
		provide() {
			return {
				openAlert: this.openAlert,
				openToast: this.openToast,
			};
		},
		async mounted() {
			try {
				const parseJsonSafe = (value) => {
					if (!value || typeof value !== 'string') {
						return null;
					}

					try {
						return JSON.parse(value);
					} catch (e) {
						return null;
					}
				};

				const resolvedFormData       = parseJsonSafe(sessionStorage.getItem('formData'));
				const resolvedCoordinates    = parseJsonSafe(sessionStorage.getItem('coordinates'));
				const resolvedSearchLocation = parseJsonSafe(sessionStorage.getItem('searchLocation'));

				this.formData.rooms = [];

				if (resolvedFormData) {
					this.skipRoomsWatcher = true;

					this.formData.locationSearch = resolvedFormData.locationSearch || '';
					this.formData.locationRadius = resolvedFormData.locationRadius || '';
					this.formData.checkIn        = resolvedFormData.checkIn || '';
					this.formData.checkOut       = resolvedFormData.checkOut || '';
					this.formData.numRooms       = Number(resolvedFormData.numRooms) || 1;

					(resolvedFormData.rooms || []).forEach((room, index) => {
						this.formData.rooms.push({
							roomNumber  : room.roomNumber || (index + 1),
							numAdults   : room.numAdults || 2,
							numChildren : room.numChildren || 0,
							childrenAges: room.childrenAges || []
						});
					});

					this.skipRoomsWatcher = false;
				}

				if (resolvedCoordinates) {
					this.coordinates = resolvedCoordinates;
				} else if (resolvedSearchLocation) {
					this.coordinates = {
						lat     : resolvedSearchLocation.lat,
						lng     : resolvedSearchLocation.lng,
						place_id: resolvedSearchLocation.place_id,
						radius  : resolvedSearchLocation.radius
					};
				}

				const checkInDate  = new Date(this.formData.checkIn);
				const checkOutDate = new Date(this.formData.checkOut);

				if (checkOutDate <= checkInDate) {
					return 0;
				}

				const timeDifference = checkOutDate - checkInDate;
				this.numNights = timeDifference / (1000 * 60 * 60 * 24);
				this.totalRooms = this.formData.rooms.length;

			} catch (error) {
				console.error('Error parsing local storage data:', error);
			}
		}
	};

	function initializeDB() {
		return new Promise((resolve, reject) => {
			const request = indexedDB.open('CpMaxxHotels', 1);

			request.onerror = (event) => {
				reject("Database error: " + event.target.error);
			};

			request.onsuccess = (event) => {
				resolve(event.target.result);
			};

			request.onupgradeneeded = (event) => {
				const db = event.target.result;
				if (!db.objectStoreNames.contains('hotels')) {
					db.createObjectStore('hotels');
				}
			};
		});
	}

$(document).ready(function documentReady() {
	 // initialize app and register components
	const app = Vue.createApp(appConfig);

	app.config.globalProperties.$hotelDb = {
		async storeHotels(key, data) {
			const db = await initializeDB();
			return new Promise((resolve, reject) => {
				const transaction = db.transaction(['hotels'], 'readwrite');
				const store = transaction.objectStore('hotels');

				const request = store.put(data, key);

				request.onsuccess = () => {
					resolve('Hotels data stored successfully');
				};

				request.onerror = (event) => {
					reject('Error storing hotels data: ' + event.target.error);
				};
			});
		},
		async getHotels(key) {
			const db = await initializeDB();
			return new Promise((resolve, reject) => {
				const transaction = db.transaction(['hotels'], 'readonly');
				const store = transaction.objectStore('hotels');
				const request = store.get(key);

				request.onsuccess = () => {
					const result = request.result;

					if (Array.isArray(result)) {
						resolve(result);
					} else if (typeof result === 'string') {
						resolve(result);
					} else {
						resolve([]);
					}
				};

				request.onerror = (event) => {
					reject('Error retrieving hotels data: ' + event.target.error);
				};
			});
		},
		async deleteHotels(key) {
			const db = await initializeDB();
			return new Promise((resolve, reject) => {
				const transaction = db.transaction(['hotels'], 'readwrite');
				const store = transaction.objectStore('hotels');
				const request = store.delete(key);

				request.onsuccess = () => {
					resolve(`Hotels with key ${key} deleted successfully`);
				};

				request.onerror = (event) => {
					reject(`Error deleting hotels: ${event.target.error}`);
				};
			});
		},
		async deleteDB() {
			return new Promise((resolve, reject) => {
				const deleteRequest = indexedDB.deleteDatabase('CpMaxxHotels');

				deleteRequest.onsuccess = () => {
					resolve('Database successfully deleted');
				};

				deleteRequest.onerror = (event) => {
					reject(`Error deleting database: ${event.target.error}`);
				};

				deleteRequest.onblocked = () => {
					reject('Database deletion was blocked. Please close all other tabs with this site open');
				};
			});
		}
	};

	app.component('adzuki-alert', Adzuki.VueComponents.AdzukiAlert);
	app.component('adzuki-toast', Adzuki.VueComponents.AdzukiToast);
	app.component('adzuki-loading', Adzuki.VueComponents.AdzukiLoading);
	app.component('adzuki-modal', Adzuki.VueComponents.AdzukiModal);
	app.component('he-room-config', Adzuki.VueComponents.HotelEngineRoomConfig);
	app.component('he-search-form', Adzuki.VueComponents.HotelEngineSearchForm);


	app.directive('formatCurrency', Adzuki.VueDirectives.FormatCurrency);
	app.directive('formatDate', Adzuki.VueDirectives.FormatCurrency);
	app.mount('#he-search');

});
}(jQuery, window.Adzuki || {}));
